import { useNavigate } from 'react-router-dom';
import { Card, CardTitle } from '@/components/ui/card';

interface Tile {
  title: string;
  sub: string;
  to: string;
}

const TILES: Tile[] = [
  { title: 'Hub operativo', sub: 'mapa en vivo', to: '/operativa' },
  { title: 'Estadística', sub: 'memoria anual', to: '/estadisticas' },
  { title: 'Registrar aviso', sub: 'alta manual', to: '/altaAviso' },
  { title: 'Vehículos', sub: 'revisiones', to: '/vehiculos' },
];

export function QuickAccessCard() {
  const navigate = useNavigate();
  return (
    <Card className="p-[16px]">
      <CardTitle className="mb-[12px]">Accesos rápidos</CardTitle>
      <div className="grid grid-cols-2 gap-[10px]">
        {TILES.map((tile) => (
          <button
            type="button"
            key={tile.title}
            onClick={() => navigate(tile.to)}
            className="cursor-pointer rounded-[7px] border border-s-line px-[12px] py-[14px] text-left text-[12px] font-semibold text-s-text transition-colors hover:border-s-accent hover:bg-s-accentSoft"
          >
            {tile.title}
            <div className="mt-[4px] font-mono text-[9px] font-normal text-s-dim">
              {tile.sub}
            </div>
          </button>
        ))}
      </div>
    </Card>
  );
}
